<template>
  <modal ref="modal" class="formens-modal">
    <span slot="activator">
      <slot name="activator"></slot>
    </span>
    <div slot="header">Formens Product</div>
    <div slot="toolbar" class="ui left aligned">
      <div v-if="!ready" class="ui disabled positive button">Validate</div>
      <div v-if="ready" class="ui positive button" @click="addToCart()">
        Validate
      </div>
    </div>
    <div class="content">
      <div class="editor">
        <div class="line">
          <label>Formens Ref</label>
          <input v-model="formensProduct.formens_ref" />
        </div>
        <div class="line">
          <label>Product Type</label>
          <input v-model="formensProduct.product_type" />
        </div>
        <div class="line">
          <label>Fabric Ref</label>
          <input v-model="formensProduct.fabric_ref" />
        </div>
        <div class="line">
          <label>Pattern Base</label>
          <input v-model="formensProduct.pattern_base" />
        </div>
        <div class="line">
          <label>Base Size</label>
          <input v-model="formensProduct.base_size" />
        </div>
        <div class="line">
          <label>Suggested Price</label>
          <input v-model.number="formensProduct.price" />
        </div>
        <div class="line">
          <label>Match Prestashop Product</label>
        </div>
        <div v-if="id_product" class="line">
          <p>
            <span v-if="id_product">
              <span class="product-key">Product id</span> :
              <span class="formens">{{ id_product }}</span>
            </span>
            &nbsp;
            <span v-if="id_product_attribute">
              <span class="product-key">Combination id</span> :
              <span class="formens">{{ id_product_attribute }}</span>
            </span>
          </p>
        </div>
        <div class="line">
          <input
            class="search-input"
            v-if="!products.length"
            v-model="keyword"
            placeholder="Search Prestashop products here"
          />
          <select v-else v-model="id_product">
            <option
              v-for="product in products"
              :key="product.id_product"
              :value="product.id_product"
            >
              {{ product.name + ' - ' + product.formatted_price }}
            </option>
          </select>
          <span class="actions">
            <span v-if="!products.length">
              <i v-if="disableSearch" class="ui disabled blue search icon"></i>
              <i v-else class="ui blue search icon" @click="search"></i>
            </span>
            <span>
              <i
                v-if="disableClearProduct"
                class="ui disabled red eraser icon"
              ></i>
              <i v-else class="ui red eraser icon" @click="clearProduct"></i>
            </span>
          </span>
        </div>
        <div v-if="currentProductCombinations">
          <div class="line">
            <label>Product combination</label>
          </div>
          <div class="line">
            <select v-model="id_product_attribute">
              <option
                v-for="combination in currentProductCombinations"
                :key="combination.id_product_attribute"
                :value="combination.id_product_attribute"
                :selected="combination.default_on == '1' ? 'selected' : ''"
              >
                {{ combination.attributes }} - {{ combination.formatted_price }}
              </option>
            </select>
            <span class="actions">
              <i
                v-if="disableClearCombination"
                class="ui disabled orange eraser icon"
              ></i>
              <i
                v-else
                class="ui orange eraser icon"
                @click="clearCombination"
              ></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<style scoped>
.editor {
  width: 680px;
  font-size: 20px;
}

.line {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}

.search-input {
  width: 80%;
}

.product-key {
  color: green;
}

.formens {
  color: #e61a8d;
}

.actions {
  width: 120px;
  font-size: 40px;
  margin-left: 15px;
}

.search {
  float: left;
}

.eraser {
  float: right;
}
</style>
<script>
import axios from 'axios'

export default {
  name: 'FormensModal',
  props: {
    formensProduct: {
      type: Object,
      default: () => ({
        formens_ref: '',
        product_type: '',
        fabric_ref: '',
        pattern_base: '',
        base_size: '',
        formens_price: null,
        price: null,
        id_product: null,
        id_product_attribute: null
      })
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      keyword: '',
      searching: false,
      id_product: null,
      products: [],
      id_product_attribute: null
    }
  },
  computed: {
    disableSearch() {
      return !this.keyword
    },
    disableClearProduct() {
      return !this.keyword || !this.products.length
    },
    disableClearCombination() {
      return !this.id_product_attribute
    },
    currentProduct() {
      if (!this.id_product) return null
      return this.products.filter(
        (product) => product.id_product === this.id_product
      )[0]
    },
    currentProductCombinations() {
      if (!this.currentProduct) return null
      if (Array.isArray(this.currentProduct.combinations)) return null
      return this.currentProduct.combinations
    },
    attributeList() {
      if (!this.currentProductCombinations || !this.id_product_attribute)
        return {}
      return this.currentProductCombinations[this.id_product_attribute]
        .attribute_list
    },
    ready() {
      if (
        this.formensProduct.price > 0 &&
        this.id_product &&
        ((this.currentProductCombinations && this.id_product_attribute) ||
          !this.currentProductCombinations)
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    open() {
      this.clearPrestaFields()
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    search() {
      if (!this.keyword) return
      this.searching = true
      axios
        .get('/products', {
          params: {
            product_search: this.keyword,
            searcher_email: this.user.email,
            size: 100,
            page: 1
          }
        })
        .then((response) => {
          // eslint-disable-next-line no-param-reassign
          this.products = response.data.products
        })
        .finally(() => {
          this.searching = false
        })
    },
    clearProduct() {
      this.keyword = ''
      this.products = []
      this.id_product = null
    },
    clearCombination() {
      this.id_product_attribute = null
    },
    clearPrestaFields() {
      this.clearProduct()
      this.clearCombination()
    },
    getPrestaPrice() {
      if (
        this.id_product_attribute &&
        this.currentProduct.combinations &&
        this.currentProduct.combinations[this.id_product_attribute]
      ) {
        return parseInt(
          this.currentProduct.combinations[this.id_product_attribute].formatted_price.replace(' ',''),
          10
        )
      }
      return parseInt(this.currentProduct.formatted_price.replace(' ',''), 10)
    },
    addToCart() {
      const payload = Object.assign(
        this.formensProduct,
        { id_product: this.id_product},
        {
          id_combination: this.id_product_attribute
            ? this.id_product_attribute
            : null
        },
        { presta_price: this.getPrestaPrice() },
        { product_image: this.currentProduct.product_image },
        { name: this.currentProduct.name },
        { reference: this.currentProduct.reference },
        { attribute_list: this.attributeList },
        { customizable: 0 }
      )
      this.$emit('addToCart', payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormensModal.vue?43ad43fc